import {
    availableCastingJobTypes,
    availableMasterOfCeremoniesJobTypes,
    availableEventSupportJobTypes,
    availableBarsRestaurantsJobTypes
} from '@/helpers/availableJobTypeHelper'

export default function () {
    return {
        allAvailableJobTypes: [
            ...availableCastingJobTypes,
            ...availableMasterOfCeremoniesJobTypes,
            ...availableEventSupportJobTypes,
            ...availableBarsRestaurantsJobTypes
        ],
        billingTime: null,
        errors: {
            billingTime: null,
            event: null
        },
        showCompletedJobDialog: false,
        showErrorDialog: false
    }
}
